import { router } from "@inertiajs/vue3";
import axios from "axios";
import { eventBus } from "@/Helpers/eventbus.js";

export const UserRequests = {
    PaywallRedirected: (data) => {
        let redirectData = {
            trigger: data.trigger,
            partner: data.partner ?? null,
            force: data.force ?? false,
            redirectBack: data.redirectBack ?? false,
        };

        const { trigger, partner, force, redirectBack } = redirectData;

        if (
            (route().current() === "inbox.messenger.show" ||
                route().current() === "inbox.messenger.show.hidden") &&
            redirectBack
        ) {
            axios
                .post(route("internals.trigger.paywall", trigger), {
                    partner: partner?.unique_identifier,
                    force: force,
                    redirectBack: redirectBack,
                })
                .then((response) => {
                    eventBus.flash.banner = response.data.banner;
                    eventBus.flash.partner = response.data.partner;
                    eventBus.flash.bannerData = response.data.bannerData;
                    eventBus.flash.context = response.data.context;
                });
        } else {
            router.post(
                route("internals.trigger.paywall", trigger),
                {
                    partner: partner?.unique_identifier,
                    force: force,
                    redirectBack: redirectBack,
                },
                {
                    preserveScroll: redirectBack,
                }
            );
        }
    },
    BannerRedirected: (data) => {
        if (
            route().current() === "inbox.messenger.show" ||
            route().current() === "inbox.messenger.show.hidden"
        ) {
            axios
                .post(route("internals.trigger.banner", data.banner), {
                    data: data.data ?? null,
                    relations: data.relations ?? [],
                    partner: data.partner?.unique_identifier ?? null,
                })
                .then((response) => {
                    eventBus.flash.previousBanner = eventBus.flash.banner;
                    eventBus.flash.banner = response.data.banner;
                    eventBus.flash.bannerData = response.data.bannerData;
                    eventBus.flash.user = response.data.user;
                    eventBus.flash.partner = response.data.partner;
                });
        } else {
            router.post(
                route("internals.trigger.banner", data.banner),
                {
                    data: data.data ?? null,
                    relations: data.relations ?? [],
                    partner: data.partner?.unique_identifier ?? null,
                },
                {
                    preserveState: true,
                    preserveScroll: true,
                }
            );
        }
    },
    BannerReset: () => {
        router.post(
            route("internals.reset.banner"),
            {},
            {
                preserveState: true,
                preserveScroll: true,
            }
        );
    },
    Favorites: {
        toggle: (match) => {
            if (
                route().current() === "inbox.messenger.show" ||
                route().current() === "inbox.messenger.show.hidden"
            ) {
                axios.put(
                    route("partner.favorites.toggle", {
                        partner: partner.value,
                    })
                );

                return;
            }

            router.put(
                route("partner.favorites.toggle", match),
                {},
                {
                    preserveScroll: true,
                }
            );
        },
    },
    SMILEY: {
        send: (partner) => {
            if (
                route().current() === "inbox.messenger.show" ||
                route().current() === "inbox.messenger.show.hidden"
            ) {
                axios.put(route("partner.send.smiley", partner));
                eventBus.pushMessage("", "send_smile", null);

                return;
            }

            router.put(
                route("partner.send.smiley", partner),
                {},
                { preserveScroll: true }
            );
        },
    },
};
